export default {
  label: {
    notClassifiedLabels: ['Não Classificados', 'Não classificado'],
    notShowClassifiedLabel: 'Mostrar não classificados',
    showClassifiedLabel: 'Esconder não classificados',
    noData: 'Não há dados disponíveis',
  },
};
